export default __webpack_public_path__ + "static/media/ckb.d5e85141.svg";